module.exports = __webpack_public_path__ + "img/play_store.78a97693.png";